import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { FormattedMessage } from 'react-intl';

const { Option } = Select;

export const SelectTourNews = ({ handleChange }) => {
  return (
    <Select
      onChange={handleChange}
      defaultValue="TourNews in English"
      getPopupContainer={(node) => node.parentNode}
    >
      <Option value="en">
        <FormattedMessage
          id="TourNews in English"
          defaultMessage="TourNews in English"
        />
      </Option>
      <Option value="da">
        <FormattedMessage
          id="TourNews in Danish"
          defaultMessage="TourNews in Danish"
        />
      </Option>
      <Option value="de">
        <FormattedMessage
          id="TourNews in Deutsch"
          defaultMessage="TourNews in Deutsch"
        />
      </Option>
    </Select>
  );
};

SelectTourNews.propTypes = {
  handleChange: PropTypes.func,
};
